'use client';

import Icon from '@/components/shared/Icons';
import type { EventType } from '@/utils/filters/options/getEventTypeOptions';
import { useApplyFilter } from '@/hooks/useApplyFilter';

type Props = {
  options: EventType[];
  strings: {
    header: string;
    restaurant: string;
    budget: string;
    conference: string;
    party: string;
    corporate: string;
    large: string;
    outdoor: string;
    hotel: string;
    small: string;
  };
};

export default function EventTypeAndVenueTypeList({ options, strings }: Props) {
  const { applyHubPagesNavigation } = useApplyFilter();

  return (
    <div>
      <div className="leading-4 mb-2 text-b-md font-medium text-neutral-60">{strings.header}</div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {options.map(option => (
          <button
            type="button"
            aria-label={option.label}
            key={option.value}
            className="cursor-pointer rounded-xl border border-neutral-30 bg-fill hover:bg-interactive-10"
            onClick={() => applyHubPagesNavigation(option.path)}
          >
            <div className="flex-center mx-4 my-2 flex h-11 items-center">
              <Icon id={option.iconName} className="float-left mr-2 h-6 w-6" />
              <div className="flex-center items-center">
                <div className="leading-4 text-b-md font-medium text-neutral-60">{option.label}</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
